import { render, staticRenderFns } from "./qualification-certificate-apply.vue?vue&type=template&id=67dfaf13"
import script from "./qualification-certificate-apply.vue?vue&type=script&lang=js"
export * from "./qualification-certificate-apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports